<template>
  <div class="flex align-center clock-box">
    <div
        v-for="clock in clockData"
        :key="clock.id"
        class="clock-item flex align-center justify-center"
        :class="{'clock-item-active':activeId === clock.id }"
        @click="clickClock(clock)"
    >
      <div class="time-zone size12" :class="{'colorBlue':activeId === clock.id}">
        {{ clock.timezone }}
      </div>
      <!--        时间格式 hh:MM:ss-->
      <app-clock
          size="58px"
          :time="clock.date"
      ></app-clock>
    </div>

  </div>
</template>

<script>
import AppClock from "./single-clock"
export default {
  name: "clock-group",
  components:{
    AppClock
  },
  props:{
    clockData:{
      type:Array,
      default:()=>[]
    },
    activeId:null
  },
  data(){
    return {
      active:{},
    }
  },
  methods:{
    clickClock(clock){
      if(this.activeId === clock.id){
        this.active = {id:'',timezone:'',time:'',text:''}
      }else {
        this.active = clock;
      }
      this.$emit('clockChange',this.active)
    }
  }
}
</script>

<style scoped lang="scss">
.clock-box{
  background-color: #fff;
  height: 108px;
  padding: 0 16px;
  margin:9px 16px 0;
  justify-content: space-between;
  .clock-item{
    height: 88px;
    flex: 1;
    border-radius: 4px;
    background-color: #F6F7F8;
    border: 1px solid #F6F7F8;
    flex-direction: column;
    .time-zone{
      margin-bottom: 2px;
    }
  }
  .clock-item-active{
    border: 1px solid #1F6EEF;
    background-color: #EDF7FF;
  }
  .clock-item+.clock-item{
    margin-left: 18px;
  }

}
</style>